import module from 'fan/proyecto/module.js'
import template from './template.html'

export class FanProyectoColaboradoresImportarProcesadorComponent {
  constructor($filter, FanProyectoColaboradoresService) {
    this.FanProyectoColaboradoresService = FanProyectoColaboradoresService
    this.filterBy = $filter('filter')
    this.completados = []
    this.filtro = ''
    this.limite = 1
    this.pendientes = []
    this.procesando = []
    this.idProyecto = undefined
    this.rawData = undefined
    this.onChange = undefined
  }

  $onInit() {
    this.data = this.rawData
      .map((item, indice) => {
        let model = {}

        model.indice = indice
        model.id_colaborador = null
        model.colaborador = [item.personal.nombre, item.personal.apellido_paterno, item.personal.apellido_materno].join(' ')
        model.data = item
        model.procesando = false
        model.completado = false
        model.error = null
        model.status = 0

        model.procesar = () => {
          model.procesando = true
          model.status = 1

          return this.guardar(model.data)
            .then((response) => {
              model.id_colaborador = response.data.id_colaborador
              model.status = 2
            })
            .catch((response) => {
              model.error = response.data
              model.status = 3
            })
            .finally(() => {
              model.procesando = false
              model.completado = true
            })
        }

        return model
      })

    this.pendientes = [].concat(this.data)

    this.filtrar()

    this.siguiente()
  }

  guardar(data) {
    if (data.cuenta) {
      if (data.cuenta.id_banco && data.cuenta.id_moneda) {
        data.cuentas = [data.cuenta]
      }

      delete data.cuenta
    }

    return this.FanProyectoColaboradoresService.post(this.idProyecto, data)
  }

  filtrar() {
    this.resultados = this.filterBy(this.data, this.filtro)
  }

  siguiente() {
    if (this.procesando.length >= this.limite || this.pendientes.length === 0) return

    let current = this.pendientes.shift()

    current.procesar()
      .finally(() => {
        this.procesando.splice(this.procesando.indexOf(current), 1)
        this.completados.push(current)

        this.onChange({$event: {data: this.completados}})

        this.siguiente()
      })

    this.procesando.push(current)

    this.siguiente()
  }
}

module.component('fanProyectoColaboradoresImportarProcesador', {
  controller: FanProyectoColaboradoresImportarProcesadorComponent,
  template: template,
  bindings: {
    idProyecto: '<',
    rawData: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/colaboradores/importar/procesador/component.js